import baseApi from "./baseApi"

export default  {
    /**
     * Fetch absences for a given Crop Work Attendance Member
     * @return {Object} -- Alert Totals
     */

    async getCropWorkAttendanceMemberAbsences(cropWorkAttendanceMemberID) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/cropWorkAbsence/cropWorkAttendanceMember?cropWorkAttendanceMemberID=${cropWorkAttendanceMemberID}`);
        
        return result.data;
    },

    async saveCropWorkAttendanceMemberAbsence(cropWorkAbsenceDetail){
        let request = await baseApi.createHttpRequest();
        let result = await request.post(`/cropWorkAbsence/save`, cropWorkAbsenceDetail);
        console.log('api result', result)
        if(!result.data.Success) {
            throw new Error(result.data.ErrorMessages[0])
        }
        return result.data;
    },

    async deleteCropWorkAttendanceMemberAbsence(cropWorkAbsenceDetail){
        let request = await baseApi.createHttpRequest();
        let result = await request.post(`/cropWorkAbsence/del`, cropWorkAbsenceDetail);
        console.log('api result', result)
        if(!result.data.Success) {
            throw new Error(result.data.ErrorMessages[0])
        }
        return result.data;
    }
}